import { render, staticRenderFns } from "./SetUpHeaderCmp.vue?vue&type=template&id=477293c0&"
import script from "./SetUpHeaderCmp.vue?vue&type=script&lang=js&"
export * from "./SetUpHeaderCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports